// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuItem-sideMenuItem-GcHnF {
    padding: 12px 16px;
    border-radius: var(--radius-1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    margin-bottom: 4px;
    gap: 8px;
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    text-align: start;
}

.SideMenuItem-sideMenuItem-GcHnF:hover,
.SideMenuItem-sideMenuItem-GcHnF:focus,
.SideMenuItem-sideMenuItemActive-pONlr,
.SideMenuItem-sideMenuItemActive-pONlr:hover,
.SideMenuItem-sideMenuItemActive-pONlr:focus {
    background: var(--sideMenu-hover);
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    outline: none;
    -webkit-box-shadow: unset;
            box-shadow: unset;
}

.SideMenuItem-sideMenuItemIconContainer-DAjv4 {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    position: relative;
    top: 2px;
    width: 20px;
    height: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.SideMenuItem-sideMenuItemIconContainer-DAjv4 svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.SideMenuItem-sideMenuItemTextContainer-erxkG {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    white-space: pre-line;
    word-break: break-word;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/SideMenu/SideMenuItem.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,yCAAyC;IACzC,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;;IAKI,iCAAiC;IACjC,yCAAyC;IACzC,qBAAqB;IACrB,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,oBAAc;QAAd,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".sideMenuItem {\n    padding: 12px 16px;\n    border-radius: var(--radius-1);\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 4px;\n    gap: 8px;\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    text-align: start;\n}\n\n.sideMenuItem:hover,\n.sideMenuItem:focus,\n.sideMenuItemActive,\n.sideMenuItemActive:hover,\n.sideMenuItemActive:focus {\n    background: var(--sideMenu-hover);\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    outline: none;\n    box-shadow: unset;\n}\n\n.sideMenuItemIconContainer {\n    flex-shrink: 0;\n    position: relative;\n    top: 2px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sideMenuItemIconContainer svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.sideMenuItemTextContainer {\n    flex-grow: 1;\n    white-space: pre-line;\n    word-break: break-word;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuItem": `SideMenuItem-sideMenuItem-GcHnF`,
	"sideMenuItemActive": `SideMenuItem-sideMenuItemActive-pONlr`,
	"sideMenuItemIconContainer": `SideMenuItem-sideMenuItemIconContainer-DAjv4`,
	"sideMenuItemTextContainer": `SideMenuItem-sideMenuItemTextContainer-erxkG`
};
module.exports = ___CSS_LOADER_EXPORT___;
